export const UNAUTHORIZED_STATUS_CODE = 401;
export const SERVER_ERROR_STATUS_CODE = 500;
